

import templatePostListPage from '@/app-template/lib/pages/PostListPage.vue';

export default {
  name: "PostListPage",
  components: { templatePostListPage },
};
